(() => {
  const raw = new URLSearchParams(location.search).get('mi_testers');
  if (!raw) return;
  const requested = [...new Set(raw.split(',').map(v => v.trim()).filter(v => /^[\p{L} -]{1,40}$/u.test(v)))];
  if (requested.length !== 3) return;
  const config = document.querySelector('[data-mi-tester-prefill]');
  const main = document.getElementById('MainContent');
  if (!config || !main) return;
  const c = JSON.parse(config.textContent);
  const message = document.createElement('p');
  message.setAttribute('role','status');
  message.className='mi-tester-prefill-status';
  message.style.cssText='padding:16px 18px;border:1px solid #c7ae9a;background:#faf3ee;color:#201c19;font:400 14px/1.6 Mundial,Arial,sans-serif;';
  message.textContent = c.pending;
  const norm = v => String(v).trim().toLocaleLowerCase().replace(/\s+/g,' ');
  const matches = (input,name) => norm(input.getAttribute('aria-label'))===norm(name) || norm(input.value)===norm(name) || norm(input.value).endsWith(' '+norm(name));
  let finished=false, due=Date.now()+20000, scheduled=false, started=false, stable=false;
  const stop = success => {
    if(finished)return;
    finished=true;observer.disconnect();clearTimeout(deadline);
    message.textContent = success ? c.success : c.error+' '+requested.join(' · ');
    message.dataset.prefill = success ? 'success' : 'manual';
  };
  function apply() {
    scheduled=false;
    if(finished)return;
    const inputs=[...main.querySelectorAll('input.tpo-checkbox-button')];
    const targets=requested.map(name=>inputs.find(input=>matches(input,name)));
    if(targets.some(input=>!input))return;
    const group=targets[0].closest('.tpo_option-container') || targets[0].closest('.tpo_option_set-container') || targets[0].closest('label').parentElement.parentElement;
    if(!message.isConnected){group.before(message);started=true;}
    const active=inputs.filter(input=>input.checked);
    const extra=active.find(input=>!targets.includes(input));
    const missing=targets.find(input=>!input.checked);
    if(extra || missing){(extra || missing).click();setTimeout(schedule,100);return;}
    const properties=[...main.querySelectorAll('input[name^="properties["]')].filter(input=>input.name!=='properties[_tpo_add_by]');
    const valid=properties.some(input=>requested.every(name=>norm(input.value).includes(norm(name))));
    if(valid && !stable){stable=true;setTimeout(()=>{stable=false;const checked=[...main.querySelectorAll('input.tpo-checkbox-button:checked')];const validAgain=checked.length===3&&requested.every(name=>checked.some(input=>matches(input,name)));stop(validAgain);},500);}
  }
  function schedule(){if(!finished&&!scheduled&&Date.now()<due){scheduled=true;setTimeout(apply,80);}}
  const observer=new MutationObserver(schedule);
  observer.observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['value','checked']});
  const deadline=setTimeout(()=>{if(!started){const anchor=main.querySelector('h1');if(anchor)anchor.after(message);else main.prepend(message);}stop(false);},20000);
  schedule();
})();
